<div class="header">
  <div class="header-row">
    <oph-back-button (buttonClick)="backClick.emit()"></oph-back-button>

    <span class="header-label">{{ label() }}</span>

    <div class="sked-context-container sked-filter-button-group header-desktop">
      <div class="tab-indicator" [class.second]="selectedTab() === tabs()[1]?.value"></div>
      @for (tab of tabs(); track tab.value) {
        <button [class.selected]="selectedTab() === tab.value" (click)="onTabClick(tab)">
          {{ tab.label }}
        </button>
      }
    </div>

    <div class="header-right">
      <ng-content select="[slot=header-right]"></ng-content>
    </div>
  </div>

  <div class="header-row header-mobile">
    <div class="sked-context-container sked-filter-button-group">
      <div class="tab-indicator" [class.second]="selectedTab() === tabs()[1]?.value"></div>
      @for (tab of tabs(); track tab.value) {
        <button [class.selected]="selectedTab() === tab.value" (click)="onTabClick(tab)">
          {{ tab.label }}
        </button>
      }
    </div>
  </div>
</div>
